import pathToRegexp from 'path-to-regexp';

function getRouteOptions(config) {
  return Object.keys(config).map((path) => {
    const rgx = pathToRegexp(path);
    const keys = rgx.keys && rgx.keys.map(({ name }) => name);
    const Component = config[path].component;
    return { Component, path, rgx, keys };
  });
}

function testRouteMatch(pathname, options) {
  const match = options.find((path) => path.rgx.test(pathname));
  const errorMsg = 'Your pathname didn\'t match any options,\n' +
    'please check your router config and set a correct match,' +
    'or use * to set a default';

  if (!match) {
    throw new Error(errorMsg);
  }

  return match;
}

function getRouteMatch(pathname, options) {
  const match = testRouteMatch(pathname, options);
  const { Component, rgx, keys } = match;
  const result = rgx.exec(pathname);
  const values = result.slice(1);
  
  
  const params =  keys != null ? keys.reduce((previous, current, i) => Object
      .assign({}, previous, { [current]: values[i] })
    , {}) : {};


  return { Component, params };
}

function getRoute({ pathname, config, query, hash }) {
  const { Component, params } = getRouteMatch(pathname, config);
  const componentParams = Object.assign({}, { params }, { pathname, query, hash });

  return { Component, currentLocation: componentParams };
}

export { getRoute as default, getRouteOptions, getRouteMatch, testRouteMatch };

